<template>
  <div class="driver-stats">
    <DriverSettlementStatCard
      v-for="item in items"
      :key="item.key"
      v-bind="item"
    />
  </div>
</template>

<script>
import DriverSettlementStatCard from './DriverSettlementStatCard.vue'

export default {
  components: {
    DriverSettlementStatCard
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
